export const STORAGE_KEYS = {
  authSession: 'voxor.auth.session',
  selectedCompanyId: 'voxor.company.selected-id',
  welcomeSeenPrefix: 'voxor.welcome-seen.',
} as const;
